import { boolean, object } from "yup"

export const importantDocumentsSchema = object({
  signed: boolean()
    .default(false)
    .test({
      name: "signed",
      test: (v) => v === true,
      message: "yup.common.mixed.required",
    }),
})

if (import.meta.vitest) {
  const { it, expect, describe } = import.meta.vitest

  describe("importantDocumentsSchema", () => {
    it("throws when signed is not provided", async () => {
      await expect(() =>
        importantDocumentsSchema.validate({})
      ).rejects.toThrow()
    })

    it("throws when signed is false", async () => {
      await expect(() =>
        importantDocumentsSchema.validate({ signed: false })
      ).rejects.toThrow()
    })

    it("validates correctly", async () => {
      const agreement = {
        signed: true,
      }

      const result = await importantDocumentsSchema.validate(agreement)

      expect(result).toEqual(agreement)
    })
  })
}
